module.exports = __webpack_public_path__ + "img/34_8.29b1aae0.png";